import { Overrides } from '@material-ui/core/styles/overrides';

export const listItemIconOverrides: Overrides = {
  MuiListItemIcon: {
    root: {
      minWidth: '2rem'
    }
  }
};
